// extracted by mini-css-extract-plugin
module.exports = {"tyd0rci":"tyd0rci","l10yq3dx":"l10yq3dx","c1tx393d":"c1tx393d"};